import { Permission } from "./PermissionRoute";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./public_page/HomePage";
import NotFound from "./public_page/NotFound ";
import Dashboard from "./private_page/Dashboard";
import AuthPage from "./public_page/Auth/AuthPage";
import AutoLogout from "./public_page/Auth/AutoLogout";
import { useApp } from "./APIHelpers/AppContext";

function App() {
  const { LoginPermission, AllPermission } = Permission;
  const { auth } = useApp();
  return (
    <BrowserRouter>
      {auth && <AutoLogout />}
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<HomePage />} />

        {/* Public Home */}
        <Route element={<LoginPermission auth={auth} />}>
          <Route path="login" element={<AuthPage status="loginProcess" />} />
          <Route path="signup" element={<AuthPage status="startRegistration" />} />
          <Route path="signup/:token" element={<AuthPage status="startRegistration" />} />
        </Route>

        <Route path="*" element={<NotFound />} />

        {/* Public Home */}
        <Route element={<AllPermission />}>
          <Route path="home" element={<Dashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;